// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Tab, Tabs } from '@mui/material';
import Loading from '../../../components/Loading';
import { useParties } from '../../../contexts/PartiesContext';
import useProviderService from '../../../hooks/queries/registry/onboarding/useProviderService';
import useRegistrarService from '../../../hooks/queries/registry/onboarding/useRegistrarService';
import { InstrumentConfigurations } from './InstrumentConfigurations';
import { OperatorConfigurations } from './OperatorConfigurations';
import { ProviderConfigurations } from './ProviderConfigurations';

export const Configurations = () => {
  const { operator, party } = useParties();
  const providerService = useProviderService();
  const registrarService = useRegistrarService();
  const isOperator = party === operator;
  const isProvider = !!providerService.data;
  const isRegistrar = !!registrarService.data;
  const fallbackTab = isProvider ? 1 : 2;
  const defaultTab = isOperator ? 0 : fallbackTab;
  const [value, setValue] = React.useState(defaultTab);
  const isLoading = providerService.isLoading || registrarService.isLoading;
  if (isLoading) return <Loading />;

  const onChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const configurations: { [key: number]: React.ReactNode } = {
    0: <OperatorConfigurations />,
    1: <ProviderConfigurations />,
    2: <InstrumentConfigurations />,
  };
  return (
    <>
      <Tabs variant="scrollable" value={value} onChange={onChange}>
        {isOperator && <Tab value={0} label="Operator Configurations" />}
        {(isOperator || isProvider) && <Tab value={1} label="Provider Configurations" />}
        {(isOperator || isProvider || isRegistrar) && (
          <Tab value={2} label="Instrument Configurations" />
        )}
      </Tabs>
      {configurations[value]}
    </>
  );
};
